import { Box, Typography } from '@mui/material';

interface PrintHeaderProps {
  title: string;
  date?: string;
}

export function PrintHeader({ title, date }: PrintHeaderProps) {
  return (
    <Box
      sx={{
        display: 'none',
        '@media print': {
          display: 'block',
          borderBottom: '2px solid #000',
          mb: 2,
          pb: 1,
        },
      }}
    >
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Generated: {date || new Date().toLocaleDateString()}
      </Typography>
    </Box>
  );
}
